<template>
    <div class=row>
        <div class="sede-container col-md-4 col-sm-12" v-for="sede in sedi" :key="sede.id">
            
            <a class="link-maps trieste" v-if="sede.attributes.title == 'Trieste'" href="https://www.google.com/maps/place/TUDOR+NICOLAOU+STUDIO+LEGALE+ASSOCIATO/@45.649952,13.7715821,15z/data=!4m2!3m1!1s0x0:0xae0f4e488f485808?sa=X&ved=2ahUKEwiu4PLzwP3uAhU5A2MBHVTLBTIQ_BIwCnoECBsQBQ" target="_blank"></a>
            <a class="link-maps roma" v-if="sede.attributes.title == 'Treviso'" href="https://www.google.com/maps/place/Vicolo+S.+Gregorio,+10A,+31100+Treviso+TV/data=!4m2!3m1!1s0x477949d54d5e7f37:0x75ca1a79db979859?sa=X&ved=2ahUKEwiBr8TE___uAhXM26QKHTSaAcMQ8gEwAHoECAQQAQ" target="_blank"></a>
            <a class="link-maps treviso" v-if="sede.attributes.title == 'Roma'" href="https://www.google.com/maps/place/Via+Francesco+Siacci,+38,+00197+Roma+RM/data=!4m2!3m1!1s0x132f611e9b2f1a91:0xa04e5facf566f87c?sa=X&ved=2ahUKEwjjlbiZ_f_uAhXiMewKHeQiAmIQ8gEwAHoECAQQAQ" target="_blank"></a>
            <div data-aos="new-animation" data-aos-init="aos-init">
                <h1>{{sede.attributes.title}}</h1>
                <p>
                    {{labelSede}} {{sede.attributes.title}} <span v-if="sede.attributes.title == 'Trieste'"></span>{{labelSedeEng}} 
                </p>
                <p>{{sede.attributes.field_indirizzo_via}}</p>
            </div>
        </div>
    </div>
</template>
<script>

export default {
  name: 'sedi',

  props: {
      dataSedi: {
          type: String
      }
  },
  data:()=>{
        return {
            sedi:[],
            currentLang:"",
        }
  },
computed:{
labelSede(){
        if(this.$route.params.lang == "it"){
            return "Sede di "
        } 
            
    },
    labelSedeEng(){
        if(this.$route.params.lang == "en"){
            return " Office"
        } 
            
    },
},
    mounted(){
        this.currentLang = this.$route.params.lang

        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/sedi", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.sedi = json.data
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.link-maps{
    position: absolute;
    width: 100%;
    display: block;
    height: 100%;
    z-index: 99;
}
h1,p {
    color:#fff;
}
.sede-container{
    margin-top: 4rem;
    div{
        border: 1px solid rgba(255, 255, 255, 0.746);
        padding:2rem 2.7rem ;
        margin: 10px;
        opacity: 0;
        transform: translate3d(0,100px,0);
    }
    h1 {
        line-height: 2.5rem;
        font-size: 2.5rem;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
    }
}

@media (max-width:992px){

.sede-container{
    div {
        padding: 1rem 1rem;
        margin: 0px;
        h1 {
        line-height: 2rem;
        font-size: 1.5rem;
    }
     p{
         font-size: 0.875rem;
     }
    }
    
}
}
@media (max-width: 768px){
    .link-maps{
    width: 80%;
}
    .sede-container {
        margin-top: 1rem;
    }
    .sede-container > div{
        margin: 1rem 0rem 0rem;
        padding: 1rem 1.7rem;
    }
    .sede-container h1 {
        line-height: 2.5rem;
        font-size: 1.4rem;
        margin-bottom: 14px;
    }
}


</style>
